// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-2"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 5H15C15.5523 5 16 5.44772 16 6V11C16 11.5523 15.5523 12 15 12H9C8.44772 12 8 12.4477 8 13V19H16","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-2',
    ref,
    icon: element,
  },
));

Numbers2Icon.displayName = 'Numbers2Icon';

export default Numbers2Icon;
